module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/60233122896938655bd5075489ff8189.png";